class RouteViewModel extends App.Models.Route {
    modelUrl = 'RouteView';
}

App.Models.RouteView = RouteViewModel;
